import { render, staticRenderFns } from "./AprovacaoCompraItemHeader.vue?vue&type=template&id=cc573d90&"
import script from "./AprovacaoCompraItemHeader.vue?vue&type=script&lang=js&"
export * from "./AprovacaoCompraItemHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
